import { useRef } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ab1 from '../image/Partners/1_CyberSecurity/1_Fortinet Logo.png';
import ab4 from '../image/Partners/1_CyberSecurity/6_Sophos-Logo.png';
import ab7 from '../image/Partners/2_Enterprise Networking/2_Aruba_Networks-Logo.png';
import ab9 from '../image/Partners/2_Enterprise Networking/Alcatel_Mobile-Logo.png';
import ab10 from '../image/Partners/3_Infrastructure Solutions/1_NetApp-Logo.png';
import ab11 from '../image/Partners/3_Infrastructure Solutions/2_HP.png';
import ab12 from '../image/Partners/3_Infrastructure Solutions/3_Dell Logo.png';
import ab13 from '../image/Partners/8_AntiVirus/1_Trellix Logo.png';
import ab14 from '../image/Partners/3_Infrastructure Solutions/4_Lenovo-Logo.png';
import ab16 from '../image/Partners/5_Software Solutions/Microsoft-Logo.png';
import ab17 from '../image/Partners/5_Software Solutions/Adobe_Inc.-Logo.png';
import ab19 from '../image/Partners/6_Cloud Service/Amazon_Web_Services-Logo.png';
import ab20 from '../image/Partners/6_Cloud Service/Google_Cloud_Platform-Logo.png';
import ab22 from '../image/Partners/10_CCTV/1_CP Plus-LOGO.png';
import ab24 from '../image/Partners/7_Backup/1_Veeam-logo.png';
// NOTE: Azure logo was not found among your existing image folders.
// Add the correct file path once you have it, e.g.:
// import ab25 from '../image/Partners/6_Cloud Service/Azure-Logo.png';

const data = [
  {
    image: ab1,
    title: "Fortinet",
    description:
      "Fortinet delivers integrated, high-performance cybersecurity solutions that protect networks, users, and data everywhere.",
  },
  {
    image: ab4,
    title: "Sophos",
    description:
      "Sophos provides advanced endpoint and network security, helping organizations defend against today's most sophisticated cyber threats.",
  },
  {
    image: ab11,
    title: "HP",
    description:
      "HP Inc. creates technology that makes life better for everyone, everywhere — every person, every organization, and every community around the globe.",
  },
  {
    image: ab12,
    title: "Dell",
    description:
      "Dell Technologies helps organizations and individuals build their digital future and transform how they work, live and play.",
  },
  {
    image: ab10,
    title: "NetApp",
    description:
      "NetApp is a global, cloud-led, data-centric software company that empowers organizations to lead with data in the age of accelerated digital transformation.",
  },
  {
    image: ab7,
    title: "Aruba",
    description:
      "Aruba Networks, a Hewlett Packard Enterprise company, delivers secure, intelligent networking solutions for the modern digital workplace.",
  },
  {
    image: ab9,
    title: "Alcatel",
    description:
      "Alcatel delivers reliable networking and communication solutions that keep businesses and people connected around the world.",
  },
  {
    image: ab13,
    title: "Trellix",
    description:
      "Trellix delivers extended detection and response solutions, helping organizations stay ahead of evolving cyber threats.",
  },
  {
    image: ab14,
    title: "Lenovo",
    description:
      "Lenovo builds smarter technology for all, delivering innovative devices and infrastructure that power businesses worldwide.",
  },
  {
    image: ab16,
    title: "Microsoft",
    description:
      "Microsoft empowers every person and organization on the planet to achieve more through its cloud, productivity, and enterprise solutions.",
  },
  {
    image: ab17,
    title: "Adobe",
    description:
      "Adobe changes the world through digital experiences, powering creativity and productivity for businesses and individuals alike.",
  },
  {
    image: ab19,
    title: "AWS",
    description:
      "Amazon Web Services offers reliable, scalable, and cost-effective cloud computing services trusted by millions of customers globally.",
  },
  {
    image: ab20,
    title: "Google Cloud",
    description:
      "Google Cloud helps businesses innovate faster with secure, scalable infrastructure, data analytics, and machine learning solutions.",
  },
  {
    image: null, // replace with ab25 (Azure logo) once imported
    title: "Azure",
    description:
      "Microsoft Azure is a flexible cloud platform that helps organizations build, run, and manage applications across a global network of datacenters.",
  },
  {
    image: ab22,
    title: "CP Plus",
    description:
      "CP Plus is a trusted name in surveillance and security solutions, delivering advanced video security technology worldwide.",
  },
  {
    image: ab24,
    title: "Veeam",
    description:
      "Veeam provides modern data protection and backup solutions, ensuring business continuity and resilience in a hybrid cloud world.",
  },
];

function PrevArrow({ onClick }) {
  return (
    <button
      onClick={onClick}
      aria-label="Previous"
      style={{
        position: "absolute",
        left: "-24px",
        top: "50%",
        transform: "translateY(-50%)",
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        border: "none",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 2,
        fontSize: "20px",
        color: "#1f2a44",
      }}
    >
      ‹
    </button>
  );
}

function NextArrow({ onClick }) {
  return (
    <button
      onClick={onClick}
      aria-label="Next"
      style={{
        position: "absolute",
        right: "-24px",
        top: "50%",
        transform: "translateY(-50%)",
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        border: "none",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 2,
        fontSize: "20px",
        color: "#1f2a44",
      }}
    >
      ›
    </button>
  );
}

function SliderPage() {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    cssEase: "ease-in-out",
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 900, settings: { slidesToShow: 2 } },
      { breakpoint: 560, settings: { slidesToShow: 1 } },
    ],
  };

  const styles = {
    sliderSection: {
      textAlign: "center",
      padding: "60px 60px",
      backgroundColor: "#eef2fb",
      position: "relative",
    },
    eyebrow: {
      color: "#3b6df0",
      fontWeight: 700,
      fontSize: "13px",
      letterSpacing: "1px",
      textTransform: "uppercase",
      marginBottom: "10px",
    },
    sliderTitle: {
      fontSize: "30px",
      fontWeight: 800,
      color: "#111827",
      margin: "0 0 12px 0",
    },
    sliderDescription: {
      fontSize: "16px",
      color: "#6b7280",
      maxWidth: "620px",
      margin: "0 auto 40px auto",
      lineHeight: 1.6,
    },
    sliderTrack: {
      position: "relative",
      maxWidth: "1100px",
      margin: "0 auto",
    },
    sliderCard: {
      padding: "10px 12px",
    },
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      padding: "28px 22px",
      minHeight: "340px",
      boxShadow: "0 8px 24px rgba(17, 24, 39, 0.06)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
    logoBox: {
      width: "70px",
      height: "70px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "16px",
    },
    cardImage: {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
    },
    logoFallback: {
      fontSize: "16px",
      fontWeight: 700,
      color: "#3b6df0",
    },
    cardTitle: {
      fontSize: "16px",
      fontWeight: 700,
      color: "#111827",
      margin: "0 0 6px 0",
    },
    divider: {
      width: "28px",
      height: "3px",
      backgroundColor: "#3b6df0",
      borderRadius: "2px",
      margin: "0 0 14px 0",
    },
    cardText: {
      fontSize: "13.5px",
      color: "#6b7280",
      lineHeight: 1.6,
    },
    sliderFooter: {
      marginTop: "30px",
      fontSize: "16px",
      color: "#333",
    },
    ctaLink: {
      color: "#007BFF",
      textDecoration: "none",
      fontWeight: "bold",
      cursor: "pointer",
      fontSize: "18px",
    },
  };

  return (
    <div style={styles.sliderSection}>
      <div style={styles.eyebrow}>Our Partners</div>
      <h2 style={styles.sliderTitle}>Technology Partnerships That Drive Success</h2>
      <p style={styles.sliderDescription}>
        We collaborate with industry-leading technology partners to deliver innovative
        solutions and exceptional value to our clients.
      </p>

      <div style={styles.sliderTrack}>
        <Slider ref={sliderRef} {...settings}>
          {data.map((item, index) => (
            <div key={index} style={styles.sliderCard}>
              <div style={styles.card}>
                <div style={styles.logoBox}>
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={`${item.title} logo`}
                      style={styles.cardImage}
                    />
                  ) : (
                    <span style={styles.logoFallback}>{item.title}</span>
                  )}
                </div>
                <h3 style={styles.cardTitle}>{item.title}</h3>
                <div style={styles.divider} />
                <p style={styles.cardText}>{item.description}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div style={styles.sliderFooter}>
        <p>
          Want to collaborate with us?{" "}
          <a href="/contact" style={styles.ctaLink}>
            Get in touch!
          </a>
        </p>
      </div>

      <style>{`
        .slick-dots li button:before {
          font-size: 9px;
          color: #3b6df0;
          opacity: 0.35;
        }
        .slick-dots li.slick-active button:before {
          opacity: 1;
        }
      `}</style>
    </div>
  );
}

export default SliderPage;
